import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class GateDriverAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normIsrc = 570;
		this.normIsnk = 200;
		this.normVclass = 760;
		this.normVcc = 3.6;

		this.rankIsrc = 0;
		this.rankIsnk = 0;
		this.rankVclass = 0;
		this.rankVcc = 0;

		this.weightIsrc = 0.125;
		this.weightIsnk = 0.125;
		this.weightVclass = 0.125;
		this.weightVcc = 0.125;

		this.rIsrc = 0;
		this.rIsnk = 0;
		this.rVclass = 0;
		this.rVcc = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,' +
					'part_Isrc,rIsrc,rankIsrc,' +
					'part_Isnk,rIsnk,rankIsnk,' +
					'part_Vclass,rVclass,rankVclass,' +
					'part_Vcc,rVcc,rankVcc,' +
					'feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Drive Source Current  Drive Source Current Typ (A)---------------------------------------------

		[this.rankIsrc, this.rIsrc] = this.calculateRankDualSliderGTE(
			CIDS.DRIVE_SOURCE_CURRENT_TYP,
			product,
			this.normIsrc
		);

		// ---------------------------------------------Drive Sink Current  Drive Sink Current Typ (A)---------------------------------------------

		[this.rankIsnk, this.rIsnk] = this.calculateRankDualSliderGTE(CIDS.DRIVE_SINK_CURRENT_TYP, product, this.normIsnk);

		// ---------------------------------------------Voltage Class  Vclass Max (V)---------------------------------------------

		[this.rankVclass, this.rVclass] = this.calculateRankDualSliderGTE(CIDS.V_CLASS, product, this.normVclass);

		// ---------------------------------------------Device Supply  VCC Max (V)---------------------------------------------

		[this.rankVcc, this.rVcc] = this.calculateRankSingleSliderGTE(CIDS.V_CC_MAX, product, this.normVcc);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightIsrc * this.rankIsrc +
			this.weightIsnk * this.rankIsnk +
			this.weightVclass * this.rankVclass +
			this.weightVcc * this.rankVcc;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank =
			(1 - this.weightIsrc - this.weightIsnk - this.weightVclass - this.weightVcc) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
